/* eslint-disable react/jsx-props-no-spreading */
import { TextField, Autocomplete, SxProps, Theme } from "@mui/material";
import { TableInfo } from "../../services/cleaning-data-service";

interface TableAutocompleteProps {
  options: TableInfo[];
  value: TableInfo | null;
  onTableChange: (table: TableInfo | null) => void;
  disabled?: boolean;
  placeholder?: string;
  sx?: SxProps<Theme>;
}

const TableAutocomplete = ({
  options,
  value,
  onTableChange,
  disabled = false,
  placeholder = "Target Entity",
  sx,
}: TableAutocompleteProps) => {
  const handleChange = (
    event: React.SyntheticEvent,
    newValue: TableInfo | null,
  ) => {
    onTableChange(newValue);
  };

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => option.tableName}
      value={value}
      onChange={handleChange}
      size="small"
      disabled={disabled}
      sx={{
        width: "100%",
        "& .MuiOutlinedInput-root": {
          paddingRight: "8px",
          "& fieldset": {
            borderColor: "grey.400",
          },
          "&:hover fieldset": {
            borderColor: "primary.main",
          },
          "&.Mui-focused fieldset": {
            borderColor: "primary.main",
          },
        },
        ...sx,
      }}
      renderInput={(params) => (
        <TextField {...params} placeholder={placeholder} />
      )}
    />
  );
};

export default TableAutocomplete;
